(function () {
	const initProductAccordion = () => {
		const $titles = $(".about__accordion-title");
		if (!$titles.length) return;

		$titles
			.off("click.productAccordion")
			.on("click.productAccordion", function () {
				const $title = $(this);
				const $item = $title.closest(".about__accordion-item");
				const $description = $title.siblings(".about__accordion-description");
				const isOpen = $item.hasClass("active");

				if (isOpen) {
					$item.removeClass("active");
					$title.removeClass("active");
					$description.stop().slideUp(300);
				} else {
					$item.addClass("active");
					$title.addClass("active");
					$description.stop().slideDown(300);
				}
			});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
